/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { ForwardedRef, RefObject, forwardRef, useState, useEffect, useRef } from 'react';
import { MapContainer, TileLayer, Marker, Popup, Tooltip } from 'react-leaflet';
import { Button, Divider } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

// eslint-disable-next-line
const iconeSVG = "<svg xmlns='http://www.w3.org/2000/svg' height='40px' viewBox='0 -960 960 960' width='40px' fill='#e8eaed'><path d='M80-240v-80q38 0 56.5-20t77.5-20q59 0 77.5 20t54.5 20q38 0 56.5-20t77.5-20q57 0 77.5 20t56.5 20q38 0 55.5-20t76.5-20q59 0 77.5 20t56.5 20v80q-57 0-77.5-20T746-280q-36 0-54.5 20T614-240q-57 0-77.5-20T480-280q-38 0-56.5 20T346-240q-59 0-76.5-20T214-280q-38 0-56.5 20T80-240Zm0-160v-80q38 0 56.5-20t77.5-20q57 0 76.5 20t55.5 20q38 0 56.5-20t77.5-20q57 0 77 20t55 20q38 0 56.5-20t77.5-20q57 0 77.5 20t56.5 20v80q-59 0-78.5-20T746-440q-36 0-54.5 20T614-400q-57 0-77.5-20T480-440q-38 0-55.5 20T348-400q-59 0-78.5-20T214-440q-36 0-56.5 20T80-400Zm0-160v-80q38 0 56.5-20t77.5-20q57 0 76.5 20t55.5 20q38 0 56.5-20t77.5-20q57 0 77 20t55 20q38 0 56.5-20t77.5-20q57 0 77.5 20t56.5 20v80q-59 0-78.5-20T746-600q-36 0-54.5 20T614-560q-57 0-77.5-20T480-600q-38 0-55.5 20T348-560q-59 0-78.5-20T214-600q-36 0-56.5 20T80-560Z'/></svg>";

const barragemIcon = L.divIcon({
  className: 'my-custom-icon',
  html: iconeSVG,
  iconSize: [0, 0],
  iconAnchor: [21, 40],
  popupAnchor: [-2, -30]
});

export type MarkerPoint = {
  uuid: string;
  position: [number, number];
  title?: string;
  type?: string;
  ew?: string;
  ns?: string;
  elev?: number;
  update?: string;
  route: string;
  showMarker: boolean;
  icone?: string;
};

export type MapProps = {
  center: [number, number];
  markerPoints?: MarkerPoint[];
  type: string;
  show: boolean;
  ref?: RefObject<HTMLDivElement>;
  isLocation: boolean;
  zoom?: number;
  heightUser?: string;
  damName: string;
  isFullScreen?: boolean;
};

function sizeSVG(svgString: string | undefined, novoTamanho: number) {
  if (svgString) {
    const indexWidth = svgString.indexOf('width');
    const indexHeight = svgString.indexOf('height');

    const novoSVGString = svgString.substring(0, indexWidth) +
      `width="${novoTamanho}" ` +
      svgString.substring(indexWidth + svgString.substring(indexWidth).indexOf('"') + 1, indexHeight) +
      `height="${novoTamanho}" ` +
      svgString.substring(indexHeight + svgString.substring(indexHeight).indexOf('"') + 1);

    return novoSVGString;
  }
}

const MarkerDam = ({ possition, damName }: { possition: [number, number], damName: string }) => {
  return (
    <Marker position={possition} icon={barragemIcon} >
      <Tooltip permanent={true} direction='bottom'>
        {damName}
      </Tooltip>
    </Marker>
  );
};


const PopUpSelect = ({ isLocation, markerPoints, show, center, damName }:
  {
    isLocation: boolean,
    markerPoints: MarkerPoint[],
    show: boolean,
    center: [number, number],
    damName: string
  }) => {

  const navigate = useNavigate();

  return (
    <div>
      {
        isLocation ?
          <div>
            {markerPoints.map(({ position, title, route }, index) => (
              <Marker key={index} position={position} icon={barragemIcon} >
                <Tooltip permanent={true} direction='bottom'>
                  {title}
                </Tooltip>
                <Popup>
                  <div>
                    <h2>{title}</h2>
                    <Button variant='contained' fullWidth onClick={() => navigate(route)}>
                      Detalhes
                    </Button>
                  </div>
                </Popup>
              </Marker>
            ))}
          </div>
          :
          <div>
            {markerPoints.map(({ position, title, type, ew, ns, elev, update, showMarker, icone }, index) => (
              showMarker ? (
                <Marker key={index} position={position}
                  icon={L.divIcon({
                    className: 'marker',
                    html: sizeSVG(icone, 28),
                    iconSize: [0, 0],
                    iconAnchor: [21, 40],
                    popupAnchor: [-2, -30]
                  })}
                >
                  {show ? (
                    <Tooltip permanent={true} direction='bottom'>
                      {title}
                    </Tooltip>
                  ) : null}
                  <Popup>
                    <div>
                      <h2>{title}</h2>
                      <h4>{type}</h4>
                      <Divider />
                      <h4>UTM EW: {ew} </h4>
                      <h4>UTM NS: {ns} </h4>
                      <h4>Elevação: {elev}m </h4>
                      <Divider />
                      <h4>Dados da última leitura:</h4>
                      <p>{update}</p>
                    </div>
                  </Popup>
                </Marker>
              ) : null))}
          </div>
      }
    </div>
  );
};


const MapControl = ({ changeMapUrl }: { changeMapUrl: (newUrl: string) => void }) => {

  const [variant, setVariant] = useState<string>('Satélite');

  function changeButtom(type: string) {

    if (type == 'Satélite') {
      changeMapUrl('https://mt1.google.com/vt/lyrs=y&x={x}&y={y}&z={z}');
      setVariant('Satélite');
    } else if (type == 'Topográfico') {
      changeMapUrl('https://mt1.google.com/vt/lyrs=p&x={x}&y={y}&z={z}');
      setVariant('Topográfico');
    }

  }

  return (
    <div style={{ position: 'absolute', top: '10px', right: '10px', zIndex: 1000, gap: '50px' }}>
      <Button variant='contained' style={{ marginRight: '10px', ...(variant !== 'Satélite' ? { backgroundColor: 'white', color: 'black' } : {}) }} onClick={() => changeButtom('Satélite')} sx={{ borderRadius: '25px' }}>
        Satélite
      </Button>
      <Button variant='contained' style={variant !== 'Topográfico' ? { backgroundColor: 'white', color: 'black' } : {}} onClick={() => changeButtom('Topográfico')} sx={{ borderRadius: '25px' }}>
        Topográfico
      </Button>
    </div>
  );
};

export const MapRender: React.ForwardRefRenderFunction<HTMLDivElement, MapProps> = (
  { show, center, markerPoints = [], isLocation, zoom = 18, damName, isFullScreen },
  ref: ForwardedRef<HTMLDivElement>
) => {
  const leafletMapInstanceRef = useRef<L.Map | null>(null);

  const [tileLayerUrl, setTileLayerUrl] = useState(
    'https://mt1.google.com/vt/lyrs=y&x={x}&y={y}&z={z}'
  );

  const changeMapUrl = (newUrl: string) => {
    setTileLayerUrl(newUrl);
  };

  const corner1 = L.latLng(-55.98, -81.3);
  const corner2 = L.latLng(12.5, -34.8);
  const bounds = L.latLngBounds(corner1, corner2);

  useEffect(() => {
    if (ref && typeof ref !== 'function' && ref.current) {
      const mapElement = ref.current.querySelector('.leaflet-container') as HTMLElement;
      if (mapElement) {
        const map = (mapElement as any)._leaflet_map;
        if (map) {
          leafletMapInstanceRef.current = map;
          map.invalidateSize();
        }
      }
    }
  }, [isFullScreen, ref]);

  return (
    <div
      style={{
        position: isFullScreen ? 'fixed' : 'relative',
        width: isFullScreen ? '100vw' : '100%',
        height: isFullScreen ? '100vh' : '62vh',
        top: isFullScreen ? '0' : 'auto',
        left: isFullScreen ? '0' : 'auto',
        zIndex: isFullScreen ? 9999 : 'auto',
        backgroundColor: isFullScreen ? 'white' : 'transparent',
        borderRadius: isFullScreen ? '0px' : '15px',
        transition: 'all 0.3s ease-in-out',
        overflow: 'hidden'
      }}
      ref={ref}
    >
      <MapContainer
        center={center}
        zoom={zoom}
        maxZoom={18}
        minZoom={5}
        maxBounds={bounds}
        style={{
          height: '100%',
          width: '100%',
          borderRadius: 'inherit',
          position: 'relative',
        }}
      >
        <TileLayer url={tileLayerUrl} attribution='&copy; <a href="https://about.google/brand-resource-center/">GoogleMaps</a>' />
        <PopUpSelect isLocation={isLocation} markerPoints={markerPoints} show={show} center={center} damName={damName} />
        {damName !== '' ? <MarkerDam possition={center} damName={damName} /> : null}
      </MapContainer>
      <MapControl changeMapUrl={changeMapUrl} />
    </div>
  );
};

export const ForwardedMapRender = forwardRef(MapRender);